import React from 'react'

import { 
    useFormContext, 
    useFieldArray,
    useWatch 
} from 'react-hook-form'

import {
    ErrorText,
    RedTint
} from '../../../Styles/BaseStyles'

import { 
    SectionDiv, 
    HeaderDiv, 
    FormDiv, 
    SectionHeader, 
    ApplicationRowDiv,
    LeftApplicationDiv,
    RightApplicationDiv,
    FullApplicationDiv,
    ApplicationHeader,
    InputField,
    BodyTextArea, 
    AddButtonDiv, 
    DeleteButtonDiv, 
    AddButton, 
    DeleteButton
} from  '../../../Styles/Components/ApplicationSectionStyles'

// Redux selector

import { useSelector } from "react-redux";

function ProjectSection(props){

    const { register, control, errors } = useFormContext()

    const { fields, append, remove } = useFieldArray({
        control,
        name: "projects"
    })

    const projects = useWatch({
        control,
        name: 'projects'
    })

    const locked = useSelector(state => state.appViewer.locked)

    return (
        <SectionDiv id = {props.name}>
            <HeaderDiv>
                <SectionHeader>Projects</SectionHeader>
            </HeaderDiv>
            {fields.map((item, index) => {
                return (
                    <FormDiv className="projects-form" key={item.id}>
                        <form>
                            <ApplicationRowDiv>
                                <LeftApplicationDiv>
                                    <ApplicationHeader>Name<RedTint>*</RedTint></ApplicationHeader>
                                    <InputField 
                                        type="text" name={`projects[${index}].name`} placeholder="Project Name" 
                                        ref={
                                            register({
                                                required: {
                                                    value: true,
                                                    message: 'required field'
                                                },
                                                maxLength: {
                                                    value: 50,
                                                    message: 'exceeds 50 character limit'
                                                },
                                                pattern: {
                                                    value: /^[a-zA-Z0-9 ,/()$#&\"!\+\?\-\.;:]+$/,
                                                    message: 'invalid character usage'
                                                }
                                            })
                                        } 
                                        defaultValue={item.name}
                                        readOnly={locked}
                                    />      
                                    {errors['projects'] != null && errors['projects'][index] != null && errors['projects'][index]['name'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['projects'][index]['name']['message']}</ErrorText>}
                                </LeftApplicationDiv>
                                <RightApplicationDiv>
                                    <ApplicationHeader>Link</ApplicationHeader>
                                    <InputField 
                                        type="text" name={`projects[${index}].link`} placeholder="Project Link" 
                                        ref={
                                            register({
                                                maxLength: {
                                                    value: 2048,
                                                    message: 'exceeds 2048 character limit'
                                                },
                                                pattern: {
                                                    value: /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9\-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9\-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/,
                                                    message: 'invalid format or character usage'
                                                }
                                            })
                                        } 
                                        defaultValue={item.link}
                                        readOnly={locked}
                                    />
                                    {errors['projects'] != null && errors['projects'][index] != null && errors['projects'][index]['link'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['projects'][index]['link']['message']}</ErrorText>}
                                </RightApplicationDiv>
                            </ApplicationRowDiv>
                            <ApplicationRowDiv>
                                <FullApplicationDiv>
                                    <ApplicationHeader>Description</ApplicationHeader>
                                    <BodyTextArea 
                                        type="text" name={`projects[${index}].description`} placeholder="Description" 
                                        ref={
                                            register({
                                                
                                            })
                                        }  
                                        defaultValue={item.description}
                                        readOnly={locked}
                                    />
                                    {errors['projects'] != null && errors['projects'][index] != null && errors['projects'][index]['description'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['projects'][index]['description']['message']}</ErrorText>}
                                </FullApplicationDiv>
                            </ApplicationRowDiv>
                            {fields.length != 0 && !locked ? 
                                <DeleteButtonDiv>
                                    <DeleteButton type="button" onClick={() => remove(index)}>Delete</DeleteButton>
                                </DeleteButtonDiv> : null
                            }
                        </form>
                    </FormDiv>
                );
            })}
            {!locked ?
                <AddButtonDiv>
                    <AddButton type="button" onClick={() => {append({name: "", description: "", link: ""})}}>Add Project</AddButton>
                </AddButtonDiv> : null
            }
        </SectionDiv>
    )
}

export default ProjectSection;